export function stepsScroll() {

    let header = $(".header");
    $(".get-started-steps .step-variants li").on("click", function (event) {
        let $parent = $(this).parent(".step-variants");
        let scrollTop = $parent.offset().top;
        let parentHeight = $parent.innerHeight();
        $("html, body").animate({
            scrollTop: scrollTop + parentHeight - header.innerHeight()
        }, 500);
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/stepsScroll.js